// V_TC_PDP_50 winner: show shipping timeline for returning US visitors
document.addEventListener('DOMContentLoaded', function () {
  const locationEl = document.querySelector('.c-shipping-timeline__location');
  if (!locationEl) return;

  if (!localStorage.getItem('tc_pdp50_visited')) {
    localStorage.setItem('tc_pdp50_visited', '1');
    return;
  }

  const wrapper = document.querySelector('.c-shipping-timeline');

  fetch('https://get.geojs.io/v1/ip/geo.json')
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (!data || !data.country_code) return;

      if (data.country_code === 'US') {
        const location = data.region || (wrapper && wrapper.dataset.country === 'US' ? 'United States' : null);
        if (location) {
          locationEl.textContent = location;
          document.body.classList.add('c-pdp50-ready');
        }
      }
    })
    .catch(function () {
      if (wrapper && wrapper.dataset.country === 'US') {
        locationEl.textContent = 'United States';
        document.body.classList.add('c-pdp50-ready');
      }
    });
});

// V_TC_PDP_43 winner: show Built to Last gallery for new visitors only
document.addEventListener("DOMContentLoaded", function () {
  if (!localStorage.getItem("tc_pdpBuiltToLast_seen")) {
    document.body.classList.add("c-pdpBuiltToLastVarA");
    localStorage.setItem("tc_pdpBuiltToLast_seen", "1");
  }
});

// PDP Built to Last Image - Remove modal item from DOM for returning visitors so it isn't counted or navigable
// Runs only on DOMContentLoaded — body class is already set above before this fires.
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("c-pdpBuiltToLastVarA")) return;
  document.querySelectorAll(".c-built-to-last-modal-item").forEach(function (el) {
    el.remove();
  });
});


// PDP Built to Last Image - Track click on built-to-last image (3rd position) in Var A
// Fires on: main gallery image click, zoom button click, thumbnail click
document.addEventListener("DOMContentLoaded", function () {
  var btlWrapper = document.querySelector(".c-pdpBuiltToLast-vara-gallery");
  if (!btlWrapper) return;

  btlWrapper.addEventListener("click", function (e) {
    // Main gallery item and zoom button use data-media-id; thumbnails use data-target
    var isMainItem = e.target.closest('[data-media-id$="-built-to-last"]');
    var isThumbnail = e.target.closest('.c-built-to-last-thumbnail');
    if (!isMainItem && !isThumbnail) return;

    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: "builtToLastImageClicked" });
  });
});

// V_TC_HP_60 | Customer Favourites — click tracking
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a");
    if (!link) return;
    if (!link.closest(".c-hp60-section")) return;
    window.igEvents = window.igEvents || [];
   window.igEvents.push({"event": "customer_favourites_click"});
  });
});

// V_TC_PDP_65 | Product Wayfinding - Sticky Menu - PDP
(function () {
  var armedSummary = null;
  var savedScrollX = 0;
  var savedScrollY = 0;

  function findMenuSummary() {
    return (
      document.querySelector(
        "header-drawer.c-header-drawer-nav51-var-b summary.header__icon--menu"
      ) || document.querySelector("header-drawer summary.header__icon--menu")
    );
  }

  // The drawer's own open/close logic returns keyboard focus to this summary
  // (it lives up in the header). Since we're triggering it from a button down
  // by the sticky ATC, that focus-return scrolls the page back to the header.
  // Restore the scroll position whenever focus lands here while "armed", and
  // disarm once the drawer has actually finished closing.
  document.addEventListener(
    "focusin",
    function (e) {
      if (e.target === armedSummary) {
        window.scrollTo(savedScrollX, savedScrollY);
      }
    },
    true
  );

  function openMenuDrawer() {
    var summary = findMenuSummary();
    if (!summary) return;

    savedScrollX = window.scrollX;
    savedScrollY = window.scrollY;
    armedSummary = summary;

    var details = summary.closest("details");
    if (details) {
      var observer = new MutationObserver(function () {
        if (!details.hasAttribute("open")) {
          armedSummary = null;
          observer.disconnect();
        }
      });
      observer.observe(details, { attributes: true, attributeFilter: ["open"] });
    }

    summary.click();
  }

  function injectWayfindingToggle() {
    if (document.querySelector(".c-wayfinding-toggle")) return;

    var button = document.createElement("button");
    button.type = "button";
    button.className = "c-wayfinding-toggle";
    button.setAttribute("aria-label", "Open menu");
    button.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M1.26172 6.30859H26.4998M1.26172 13.88H26.4998M1.26172 21.4515H26.4998" stroke="white" stroke-width="1.76667" stroke-linecap="round"/>' +
      "</svg>";

    button.addEventListener("click", openMenuDrawer);
    document.body.appendChild(button);
  }

  document.addEventListener("DOMContentLoaded", injectWayfindingToggle);
  window.addEventListener("ig:ready", injectWayfindingToggle);
})();

